import { render, staticRenderFns } from "./Repaymnet.vue?vue&type=template&id=489cd967&scoped=true"
import script from "./Repaymnet.vue?vue&type=script&lang=js"
export * from "./Repaymnet.vue?vue&type=script&lang=js"
import style0 from "./Repaymnet.vue?vue&type=style&index=0&id=489cd967&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489cd967",
  null
  
)

export default component.exports